import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationPackage } from 'src/app/enums/application-package.enum';
import { Service } from 'src/app/enums/service.enum';
import { Observable } from 'rxjs';
import { ResponseObj } from 'src/app/main/responseObj';
import { HttpClient } from '@angular/common/http';
import { OpUserP } from '../data';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  readonly baseUrl = environment.endPoint + ApplicationPackage.AUTH_OP + Service.OPERATIONAL;

  readonly usersBaseUrl = environment.endPoint + ApplicationPackage.AUTH_OP + Service.OPUSERS;
  
  constructor(private http: HttpClient) { }

  listusers(): Observable<ResponseObj> {
    return this.http.get(this.baseUrl + '/getall');
  }

  getAllUsers(): Observable<OpUserP[]> {
    return this.http.get<OpUserP[]>(this.usersBaseUrl);
  }

  getUser(id): Observable<ResponseObj> {
    return this.http.get(this.baseUrl + '/getbyid/' + id)
  }

  addOpUser(inputOpUser): Observable<ResponseObj> {
    return this.http.post(this.baseUrl + '/createopuser', inputOpUser);
  }

  deleteOpUser(id): Observable<ResponseObj> {
    return this.http.delete(this.baseUrl + '/delete/' + id);
  }

  editUser(inputOpUser): Observable<ResponseObj> {
    return this.http.put(this.baseUrl + '/editopuser', inputOpUser);
  }

  changePassword(currentPassword: String, newPassword: String, userID: number): Observable<ResponseObj> {
    return this.http.put(this.baseUrl + '/changepassword/' + userID + '?currentPassword=' + currentPassword + '&newPassword=' + newPassword, null);
  }

  resetPassword(userID: number): Observable<ResponseObj> {
    return this.http.post(this.baseUrl + '/resetpassword/' + userID, null);
  }

  createClientUser(cusid, username, password, createchannel): Observable<ResponseObj> {
    const formData: FormData = new FormData();
    formData.append("cusid", cusid);
    formData.append("username", username);
    formData.append("password", password);
    formData.append("createchannel ", createchannel);
    return this.http.post(this.baseUrl + '/createclientuser', formData);
  }
}
